import { ChangeDetectorRef, Component, OnInit, OnDestroy } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditIdiomasComponent } from "./edit-idiomas/edit-idiomas.component";
import { MicroserviceService } from "@sharedV11/services/microservices/microservice.service";
import { interval, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-traducciones",
  templateUrl: "./traduccion.component.html",
  styleUrls: ["./traduccion.component.scss"],
})
export class TraduccionesComponent extends SuperClassComponent implements OnInit, OnDestroy {
  private tokenCheckSubscription: Subscription;
  customanPkId: any;
  customanMode: any = 'I';

  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef,
    private microserviceService: MicroserviceService
  ) {
    super(panelService, cdRef);
  }

  ngOnInit() {
    // Verificar token al cargar la página
    this.checkTokenOnInit();

    // Verificar token cada 2 minutos de forma proactiva
    this.tokenCheckSubscription = interval(2 * 60 * 1000).subscribe(() => {
      this.microserviceService.checkAndRefreshToken(5).catch((error) => {
        console.error('Error al verificar/refrescar token periódicamente:', error);
      });
    });

    // Escuchar cambios en la configuración del panel desde TableComponent
    this.panelService.panelConfig$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((config) => {
        if (config && config.panel) {
          this.customanpanel = config.panel;
          this.customanPkId = config.pkId;
          this.customanMode = config.mode;
          this.editChangeCss();
          this.cdRef.detectChanges();
        }
      });

    // Escuchar cuando se cierra el panel (botón X o después de guardar)
    this.panelService.closePanel$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((closeSignal) => {
        if (closeSignal !== null && this.customanpanel !== undefined) {
          console.log('[TraduccionesComponent] Cerrando panel y volviendo a la tabla');
          this.customanpanel = undefined;
          this.customanPkId = null;
          this.customanMode = 'I';
          this.closePanelChangeCss();
          this.cdRef.detectChanges();
        }
      });
  }

  ngOnDestroy() {
    if (this.tokenCheckSubscription) {
      this.tokenCheckSubscription.unsubscribe();
    }
  }

  private checkTokenOnInit() {
    // Verificar y refrescar token si está próximo a expirar
    this.microserviceService.checkAndRefreshToken(5).catch((error) => {
      console.error('Error al verificar token inicial:', error);
    });
  }

  openPanel() {
    this.customanpanel = EditIdiomasComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
